import { useQuery } from '@tanstack/react-query';
import { providerNextAppointmentPerPatient } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useProviderNextAppointmentPerPatientQuery = (patientId: string, opts?: BaseQueryOpts) => useQuery({
  queryKey: [ 'nextAppointmentPerPatient' ],
  queryFn: () => providerNextAppointmentPerPatient(),
  select: (data) => data.data?.[patientId],
  ...opts
});
